const BOOTSTRAP_BROWSER_BASEURL = '/bootstrap-browser';

export const getBootstrapVersion = async (): Promise<string | undefined> => {
  const response = await fetch(`${BOOTSTRAP_BROWSER_BASEURL}/version.json`);
  if (response.status === 200) {
    return (JSON.parse(await response.text()) as {version: string}).version;
  } else {
    return undefined;
  }
};
